import React, { useState, useEffect } from "react";
import GroupsPanel from "../components/GroupsPanel";
import UsersPanel from "../components/UsersPanel";
import TeamsPanel from "../components/TeamsPanel";
import AuditLogPanel from "../components/AuditLogPanel";

import {
    Box,
    Typography,
    Tabs,
    Tab,
    Paper,
    useTheme
} from "@mui/material";

import "../styles/SecurityAdmin.css";

const SecurityAdmin: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [mounted, setMounted] = useState(false);
    const theme = useTheme();

    const tabLabels = ["Groups", "Users", "Teams", "Auditing"];

    useEffect(() => {
        setMounted(true);
    }, []);

    return (
        <Box
            className="security-admin"
            sx={{
                p: 3,
                mt: 6,
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
                minHeight: "100vh",
            }}
        >
            <Typography variant="h5" gutterBottom>
                Security Administration
            </Typography>

            <Paper
                elevation={1}
                sx={{
                    mb: 2,
                    borderBottom: 1,
                    borderColor: "divider",
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 2,
                }}
            >
                <Tabs
                    value={selectedTab}
                    onChange={(_, newIndex) => setSelectedTab(newIndex)}
                    variant="scrollable"
                    scrollButtons="auto"
                    textColor="inherit"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: theme.palette.primary.main,
                        },
                    }}
                    sx={{
                        ".MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 500,
                            color: theme.palette.text.primary,
                        },
                        ".Mui-selected": {
                            color: theme.palette.primary.main,
                        },
                    }}
                >
                    {tabLabels.map((label) => (
                        <Tab key={label} label={label} />
                    ))}
                </Tabs>
            </Paper>

            {mounted && (
                <Box className="content-panel">
                    <Box sx={{ display: selectedTab === 0 ? "block" : "none" }}>
                        <GroupsPanel />
                    </Box>
                    <Box sx={{ display: selectedTab === 1 ? "block" : "none" }}>
                        <UsersPanel />
                    </Box>
                    <Box sx={{ display: selectedTab === 2 ? "block" : "none" }}>
                        <TeamsPanel />
                    </Box>
                    <Box sx={{ display: selectedTab === 3 ? "block" : "none" }}>
                        <AuditLogPanel />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default SecurityAdmin;
